import { render, staticRenderFns } from "./model.vue?vue&type=template&id=2742e6dc"
import script from "./model.vue?vue&type=script&lang=ts"
export * from "./model.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports